import React, { useState, useEffect } from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Gallery from './components/Gallery';
import Videos from './components/Videos';
import Services from './components/Services';
import Packages from './components/Packages';
import Vendors from './components/Vendors';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <LanguageProvider>
      <div className="App paper-bg">
        <Navbar isScrolled={isScrolled} />
        <Hero />
        <About />
        <Gallery />
        <Videos />
        <Services />
        <Packages />
        <Vendors />
        <Contact />
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
